import React, { useState } from "react"
import { yyyymmdd } from "../../date-utils"
import { EquifaxBankruptcy } from "../../equifax-credit-report"


type BankruptcyProps = {
  bankruptcies: EquifaxBankruptcy[]
}

export const CodedDescriptor = ({ code, description }) => {
  if (!code) return null

  return (
    <div
    title={description}
    style={{
      whiteSpace: 'nowrap',
      maxWidth: '150px',
      fontSize: '0.8em',
      overflow: 'hidden',
      marginRight: '0.3em',
    }}><b>{code}</b> | <span style={{ color: '#aaa' }}>{description}</span>
    </div>
  )
}

const Bankruptcies = ({ bankruptcies }: BankruptcyProps) => {
  return (
    <div className="mb-2">
      <h5>Bankruptcies ({bankruptcies.length})</h5>
      {bankruptcies.length ?
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Filed</th>
                <th>Industry</th>
                <th>Filer</th>
                <th>Type</th>
                <th>Intent/Disposition</th>
                <th>Prior Int/Dis</th>
              </tr>
            </thead>
            <tbody>
              {bankruptcies?.map((b, i) => <tr key={i} title={JSON.stringify(b, null, ' ')}>
                <td>{yyyymmdd(b.dateFiled)}</td>
                <td>{b.industryCode}</td>
                <td>{b.filer}</td>
                <td>{b.type}</td>
                <td><CodedDescriptor {...b.currentIntentOrDispositionCode} /></td>
                <td><CodedDescriptor {...b.priorIntentOrDispositionCode} /></td>
              </tr>)}
            </tbody>
          </table> 
        </div> : null}
    </div >)
}

export default Bankruptcies